/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
  ColumnSortEvent,
} from 'primereact/column';
import { formatDate } from '@/utils/formatDate';

import { InputDateFilter, TableDropdownFilter } from '@/components';
import { TableData } from '@/components/Table/types';
import { StockContainersInfo } from '../../types';

export const getTableColumns = (
  data: StockContainersInfo[] | undefined
): ColumnProps[] => {
  return [
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tipo"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tamano"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'entregados',
      header: 'Entregados exp',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'transito',
      header: 'Tránsito',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      style: { fontWeight: 'bold' },
    },
    {
      field: 'reposicionVacios',
      header: 'Reposición vacíos',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'inicioOps',
      header: 'Comienzo de operaciones',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} displayMenu />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'inicioOps',
      dataType: 'date',
      body: (rowData) =>
        rowData.inicioOps ? formatDate(rowData.inicioOps) : '-',
    },
    {
      field: 'viaje',
      header: 'Viaje',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      sortFunction: (e: ColumnSortEvent) => {
        let dataSort = e.data.sort((data1: any, data2: any) => {
          const value1 = data1[e.field] as string;
          const value2 = data2[e.field] as string;
          return value1.localeCompare(value2, 'es', { sensitivity: 'base' });
        });

        if (e.order === -1) {
          dataSort = e.data.reverse();
        }
        return dataSort;
      },
    },
  ];
};
